<!-- Form -->
<form [formGroup]="this.advancedForm" (ngSubmit)="this.advancedForm.submit()">

  <div class="row">
    <div class="col-12 col-md-6">
      <h2>Informations générales</h2>
      <div class="row">
        <div class="col-12">
          <magieno-input-money-field
          [advancedFormControl]="advancedForm.formElements.costOfLiving | asAdvancedFormControl"></magieno-input-money-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <magieno-boolean-select
          [advancedFormControl]="advancedForm.formElements.isShareHolderSubjectToEI | asAdvancedFormControl"></magieno-boolean-select>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <magieno-dynamic-select
            [items]="[{key: '2025', value: '2025'}, {key: '2024', value: '2024'}, {key: '2023', value: '2023'}]"
          [advancedFormControl]="incomeTaxPersonalOptionsFormGroup.formElements.fiscalYear | asAdvancedFormControl"></magieno-dynamic-select>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-5">
    <div class="col-12 col-md-6">
      <h2>Informations sur vous</h2>
      <div class="row">
        <div class="col-12 col-md-6">
          <magieno-input-text-field
          [advancedFormControl]="mainPersonFormGroup.formElements.lastName | asAdvancedFormControl"></magieno-input-text-field>
        </div>
        <div class="col-12 col-md-6">
          <magieno-input-text-field
          [advancedFormControl]="mainPersonFormGroup.formElements.firstName | asAdvancedFormControl"></magieno-input-text-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <magieno-datepicker
          [advancedFormControl]="mainPersonFormGroup.formElements.birthdate | asAdvancedFormControl">
            <i class="fas fa-calendar" calendarIcon></i>
          </magieno-datepicker>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <magieno-boolean-select
          [advancedFormControl]="advancedForm.formElements.isMarried | asAdvancedFormControl"></magieno-boolean-select>
        </div>
      </div>

      <div class="row">
        <div class="col-12"></div>
      </div>
    </div>

    @if (advancedForm.value.isMarried === true) {
      <div class="col-12 col-md-6">
        <h2>Informations sur votre conjoint(e)</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            <magieno-input-text-field
            [advancedFormControl]="spouseFormGroup.formElements.lastName | asAdvancedFormControl"></magieno-input-text-field>
          </div>
          <div class="col-12 col-md-6">
            <magieno-input-text-field
            [advancedFormControl]="spouseFormGroup.formElements.firstName | asAdvancedFormControl"></magieno-input-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <magieno-datepicker
            [advancedFormControl]="spouseFormGroup.formElements.birthdate | asAdvancedFormControl">
              <i class="fas fa-calendar" calendarIcon></i>
            </magieno-datepicker>
          </div>
        </div>
      </div>
    }


  </div>

  <div class="row mt-5">
    <div class="col-12">
      <h2>Enfants</h2>

      <div class="row align-items-center">
        @for (childFormGroup of childrenFormArray.formGroups; track childFormGroup; let i = $index) {
          <div class="col-12 col-md-6">
            <div class="d-flex">
              <h3 class="flex-grow-1">Enfant #{{ i + 1 }}</h3>
              <div class="dropdown">
                <button class="btn btn-light" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <i class="fas fa-lg fa-ellipsis-v"></i>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <button class="dropdown-item" (click)="childrenFormArray.delete(i)">Supprimer
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <magieno-input-text-field
                [advancedFormControl]="childFormGroup.formElements.firstName | asAdvancedFormControl"></magieno-input-text-field>
              </div>
              <div class="col-12 col-md-6">
                <magieno-input-text-field
                [advancedFormControl]="childFormGroup.formElements.lastName | asAdvancedFormControl"></magieno-input-text-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6">
                <magieno-datepicker
                [advancedFormControl]="childFormGroup.formElements.birthdate | asAdvancedFormControl">
                  <i class="fas fa-calendar" calendarIcon></i>
                </magieno-datepicker>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12 col-md-6">
                <magieno-input-money-field
                [advancedFormControl]="childFormGroup.formElements.netIncome | asAdvancedFormControl"></magieno-input-money-field>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12 col-md-6">
                <magieno-input-money-field
                [advancedFormControl]="getIncomeTaxPersonalChildQuebecFormGroup(childFormGroup).formElements.careExpensesOthers | asAdvancedFormControl"></magieno-input-money-field>
              </div>
              <div class="col-12 col-md-6">
                <magieno-input-money-field
                [advancedFormControl]="getIncomeTaxPersonalChildFederalFormGroup(childFormGroup).formElements.careExpensesOthers | asAdvancedFormControl"></magieno-input-money-field>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12 col-md-6">
                <magieno-boolean-select
                [advancedFormControl]="childFormGroup.formElements.isDisabled | asAdvancedFormControl"></magieno-boolean-select>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12 col-md-6">
                <h4 class="mt-4"><i class="fad fa-hockey-sticks"></i> Camps</h4>

              </div>
            </div>

            <div class="row">

              @for (campFormGroup of getChildCamps(childFormGroup).formGroups; track campFormGroup; let j = $index) {
                <div class="col-12">
                  <div class="d-flex align-items-center">
                    <h5 class="flex-grow-1 m-0">Camp #{{ j + 1 }}</h5>
                    <div class="dropdown">
                      <button class="btn btn-light" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <i class="fas fa-lg fa-ellipsis-v"></i>
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <button class="dropdown-item"
                            (click)="getChildCamps(childFormGroup).delete(j)">
                            Supprimer
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <magieno-input-number-field
                  [advancedFormControl]="campFormGroup.formElements.numberOfWeeks | asAdvancedFormControl"></magieno-input-number-field>
                </div>

                <div class="col-12">
                  <magieno-input-money-field
                  [advancedFormControl]="campFormGroup.formElements.careExpenses | asAdvancedFormControl"></magieno-input-money-field>
                </div>
              }
            </div>

            <div class="row mt-3">
              <div class="col-12 col-md-6">
                <button class="btn btn-white" (click)="getChildCamps(childFormGroup).appendNew()"><i
                class="fad fa-plus"></i> Ajouter un camp
              </button>
            </div>
          </div>

        </div>
      }

      <div class="col-12 col-md-6 text-center add_child d-flex align-items-center justify-content-center">
        <button class="btn btn-white" (click)="addChild()"><i class="fad fa-user-plus"></i> Ajouter un
        enfant
      </button>
    </div>
  </div>


</div>
</div>

<div class="row mt-5">
  <div class="col-12">
    <h2>Informations sur votre entreprise</h2>

    <div class="row mt-4">
      <div class="col-12 col-md-3">
        <magieno-datepicker
        [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.fiscalYearStart | asAdvancedFormControl">
          <i class="fas fa-calendar" calendarIcon></i>
        </magieno-datepicker>
      </div>
      <div class="col-12 col-md-3">
        <magieno-datepicker
        [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.fiscalYearEnd | asAdvancedFormControl">
          <i class="fas fa-calendar" calendarIcon></i>
        </magieno-datepicker>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <magieno-input-money-field
        [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.businessIncome | asAdvancedFormControl"></magieno-input-money-field>
      </div>
    </div>


    <div class="row mt-4">
      <div class="col-12 col-md-6">
        <magieno-boolean-select
        [advancedFormControl]="salaryContributionsOptionsFormGroup.formElements.shouldCNTBeCalculated | asAdvancedFormControl"></magieno-boolean-select>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <magieno-boolean-select
        [advancedFormControl]="salaryContributionsOptionsFormGroup.formElements.shouldFSSBeCalculated | asAdvancedFormControl"></magieno-boolean-select>
      </div>
    </div>

    @if (salaryContributionsOptionsFormGroup.value.shouldFSSBeCalculated === true) {
      <div class="row ms-3 mt-5">
        <div class="col-12 col-md-6">
          <magieno-input-money-field
          [advancedFormControl]="salaryContributionsOptionsFormGroup.formElements.totalPayroll | asAdvancedFormControl"></magieno-input-money-field>
        </div>
        <div class="col-12 col-md-6">
          <magieno-input-money-field
          [advancedFormControl]="salaryContributionsOptionsFormGroup.formElements.totalPayrollForPrimarySector | asAdvancedFormControl"></magieno-input-money-field>
        </div>
        <div class="col-12 col-md-6">
          <magieno-boolean-select
          [advancedFormControl]="salaryContributionsOptionsFormGroup.formElements.isEmployerFromPublicSector | asAdvancedFormControl"></magieno-boolean-select>
        </div>
      </div>
    }

    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <magieno-boolean-select
        [advancedFormControl]="salaryContributionsOptionsFormGroup.formElements.shouldCNESSTBeCalculated | asAdvancedFormControl"></magieno-boolean-select>
      </div>
    </div>

    @if (salaryContributionsOptionsFormGroup.value.shouldCNESSTBeCalculated === true) {
      <div class="row ms-3 mt-5">
        <div class="col-12 col-md-6">
          <magieno-input-rate-field
            [advancedFormControl]="salaryContributionsOptionsFormGroup.formElements.recurringPaymentRate | asAdvancedFormControl"
          ></magieno-input-rate-field>
        </div>
      </div>
    }


    <div class="row mt-4">
      <div class="col-12 col-md-6">
        <magieno-select
        [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.companyType | asAdvancedFormControl"></magieno-select>
      </div>
    </div>

    @if (corporateIncomeTaxOptionsFormGroup.value.companyType === CompanyTypeEnum.privateCompany ||
      corporateIncomeTaxOptionsFormGroup.value.companyType === CompanyTypeEnum.publicCompany) {
      <div class="row mt-2 ms-3">
        <div class="col-12 col-md-6">
          <magieno-input-money-field
          [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.totalTaxableCapital | asAdvancedFormControl"></magieno-input-money-field>
        </div>
        <div class="col-12 col-md-6">
          <magieno-input-money-field
          [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.adjustedInvestmentIncome | asAdvancedFormControl"></magieno-input-money-field>
        </div>
      </div>
    } @else if (corporateIncomeTaxOptionsFormGroup.value.companyType === CompanyTypeEnum.ccpcAllYear) {
      <div class="row mt-2 ms-3">
        <div class="col-12 col-md-6">
          <magieno-input-money-field
          [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.assignedBusinessLimit | asAdvancedFormControl"></magieno-input-money-field>
        </div>
      </div>
    }

    <div class="row mt-4">
      <div class="col-12 col-md-6">
        <magieno-input-number-field
        [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.lossTaxRate | asAdvancedFormControl"></magieno-input-number-field>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 col-md-6">
        <magieno-input-money-field
        [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.capitalLossBalance | asAdvancedFormControl"></magieno-input-money-field>
      </div>
      <div class="col-12 col-md-6">
        <magieno-input-money-field
        [advancedFormControl]="corporateIncomeTaxOptionsFormGroup.formElements.nonCapitalLossBalance | asAdvancedFormControl"></magieno-input-money-field>
      </div>
    </div>
  </div>
</div>

<div class="row mt-5">
  <div class="col-12 col-md-8">

    <h2>Entreprises connectées</h2>

    @for (connectedCorporationFormGroup of connectedCorporationsFormArray.formGroups; track $index) {
      <div class="mb-5">

        <div class="d-flex">
          <h4 class="mt-4 flex-grow-1">Entreprise #{{ $index + 1 }}
            ({{ connectedCorporationFormGroup.value.title }}
          )</h4>
          <div class="dropdown">
            <button class="btn btn-light" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="fas fa-lg fa-ellipsis-v"></i>
            </button>
            <ul class="dropdown-menu">
              <li>
                <button class="dropdown-item"
                  (click)="connectedCorporationsFormArray.delete($index)">
                  Supprimer l'entreprise connectée:
                  "{{ connectedCorporationFormGroup.value.title }}"
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <magieno-input-text-field
            [advancedFormControl]="connectedCorporationFormGroup.formElements.title | asAdvancedFormControl"></magieno-input-text-field>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 col-md-6">
            <magieno-input-money-field
            [advancedFormControl]="connectedCorporationFormGroup.formElements.dividendRefundNonEligible | asAdvancedFormControl"></magieno-input-money-field>
          </div>
          <div class="col-12 col-md-6">
            <magieno-input-money-field
            [advancedFormControl]="connectedCorporationFormGroup.formElements.dividendRefundEligible | asAdvancedFormControl"></magieno-input-money-field>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 col-md-6">
            <magieno-input-money-field
            [advancedFormControl]="connectedCorporationFormGroup.formElements.nonEligibleDividendReceived | asAdvancedFormControl"></magieno-input-money-field>
          </div>
          <div class="col-12 col-md-6">
            <magieno-input-money-field
            [advancedFormControl]="connectedCorporationFormGroup.formElements.eligibleDividendReceived | asAdvancedFormControl"></magieno-input-money-field>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 col-md-6">
            <magieno-input-money-field
            [advancedFormControl]="connectedCorporationFormGroup.formElements.totalDividendPaid | asAdvancedFormControl"></magieno-input-money-field>
          </div>
        </div>
      </div>
    }

    <div class="row mt-3">
      <div class="col-12 col-md-6">
        <button class="btn btn-white" (click)="connectedCorporationsFormArray.appendNew()"><i
        class="fad fa-plus"></i> Ajouter une entreprise connectée
      </button>
    </div>
  </div>

</div>
</div>

<hr class="mt-8">

<div class="row mt-8">
  <div class="col-6 col-lg-3">

  </div>
</div>

<br>
  <br>
    <br>
      <br>

        <!-- Button -->
        @if (!isReadOnly) {
          <div class="container-fluid fixed-bottom">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <magieno-button id="saveFormButton" [button]="this.advancedForm.getButton('SAVE')"></magieno-button>
                  <magieno-button id="submitFormButton" style="margin-left: 12px"
                  [button]="this.advancedForm.getButton('SUBMIT')"></magieno-button>
                  <!--            <span class="badge rounded-pill ms-5" style="font-size: 12pt;"-->
                  <!--                  [class.bg-light]="calculationStatusEnum === 'CREATED'"-->
                  <!--                  [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"-->
                  <!--                  [class.bg-danger]="calculationStatusEnum === 'ERROR'"-->
                  <!--                  [class.bg-success]="calculationStatusEnum === 'COMPLETED'"-->
                <!--            >{{ getStatusText() }}</span>-->
                <span class="badge rounded-pill ms-3" style="font-size: 12pt;"
                  [class.bg-danger]="this.numberOfErrors > 0"
                  [class.bg-success]="this.numberOfErrors === 0">{{ this.numberOfErrors }}
                erreurs</span>
                <!--            <span style="margin-left: 15px;">Dernière sauvegarde: <strong>{{ getLastModifiedText() }}</strong></span>-->
              </div>
            </div>
          </div>
        </div>
      }


    </form>